module.exports = __webpack_public_path__ + "img/box.ad36119d.png";